import angular from 'angular';
import uiRouter from 'angular-ui-router';
import otbNavbarComponent from './otbNavbar.component';
import './otbNavbar.less';

const otbNavbarModule = angular.module('otbNavbar', [
    uiRouter
  ])
  .component('otbNavbar', otbNavbarComponent)
  .name;

export default otbNavbarModule;



// WEBPACK FOOTER //
// ./client/app/common/otbNavbar/otbNavbar.js